import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export const Yes: React.JSX.Element = <FormattedMessage id="label.yes" />;
export const No: React.JSX.Element = <FormattedMessage id="label.no" />;
